module.exports = __webpack_public_path__ + "b21e73747463b0c383cad415b63a3d74.svg";